import { Post } from '../models/wp';
import { IframeType } from 'dot-utils';

export enum PlacementTabKey {
	SelectWidget = 'select-widget',
	SelectPlacement = 'select-placement',
}

//  'after-paragraph' | 'before-paragraph' | 'after-image' | 'before-image'

export enum InsertionPoint {
	AfterParagraph = 'after-paragraph',
	BeforeParagraph = 'before-paragraph',
	AfterLastParagraph = 'after-last-paragraph',
	AfterImage = 'after-image',
	BeforeImage = 'before-image',
	AfterLastImage = 'after-last-image',
	BeforeContent = 'before-content',
	AfterContent = 'after-content',
}

export enum Alignment {
	Center = 'center',
	Left = 'left',
	Right = 'right',
}

export type PlacementMeta = {
	widget_id: string[];
	widget_title: string[];
	alignment: Alignment[];
	format: IframeType[];
	insertion_point: InsertionPoint[];
	insertion_number: string[];
	taxonomy_type: Array<'category' | 'post_tag'>;
	all_taxonomies: boolean[];
};

export interface Placement extends Post {
	categories: (number | string)[];
	tags: (number | string)[];
	// all meta items except format are one item arrays due to the way wordpress saves the post meta
	meta: PlacementMeta;
}

export enum PlacementAjaxOperation {
	ADD = 'ADD',
	UPDATE = 'UPDATE',
	DELETE = 'DELETE',
}

export const NonBlocksInsertions = [InsertionPoint.BeforeContent, InsertionPoint.AfterContent];
